import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import type { AppLang } from '../../core/lang.service';
import { CatalogApi } from '../api/catalog.api';
import { mapBanners, mapCatalog, mapPromos } from '../mappers/catalog.mapper';
import { mapStock } from '../mappers/stock.mapper';
import type { Banner } from '../models/catalog/banner.model';
import type { Catalog } from '../models/catalog/catalog.model';
import type { Promos } from '../models/catalog/promo.model';
import type { StockSnapshot } from '../models/catalog/stock.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

@Injectable()
export class CatalogHttpApi extends CatalogApi {
  private readonly http = inject(HttpClient);

  override getCatalog(lang: AppLang): Observable<Catalog> {
    return this.http.get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/position')).pipe(
      unwrapEnvelope<unknown>(),
      map((raw) => mapCatalog(raw, lang)),
      mapApiError(),
    );
  }

  /** Организацию бэкенд определяет по домену запроса — ни orgId, ни токен не нужны. */
  override getBanners(lang: AppLang): Observable<Banner[]> {
    return this.http.get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/banner')).pipe(
      unwrapEnvelope<unknown>(),
      map((raw) => mapBanners(raw, lang)),
      mapApiError(),
    );
  }

  /** Без `shareReplay`: остаток обязан перезапрашиваться на каждую смену филиала и вход в чекаут. */
  override getRemains(): Observable<StockSnapshot> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/position/remain'))
      .pipe(
        unwrapEnvelope<unknown>(),
        map((raw) => mapStock(raw)),
        mapApiError(),
      );
  }

  override getPromos(branchId: string): Observable<Promos> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/promos'), {
        params: new HttpParams().set('branchId', branchId),
      })
      .pipe(unwrapEnvelope<unknown>(), map(mapPromos), mapApiError());
  }
}
